if($('#footer').length == 0){
}
if ($('#footer').length) {
  $(".custom-footer > div ul, .custom-footer .news-item-widget, .custom-footer .doprapla, .custom-footer .banner p,  .custom-footer #formNewsletterWidget").closest(".custom-footer > div").addClass("click-able");
  $('.custom-footer > div.click-able:not(.contact) h4').click( function() {
    $(this).closest(".custom-footer > div").toggleClass("open");
  });

 $('.contact-box ul li').each(function(){
  var findfacebook = $(this).find('.facebook').html()
  var findinstagram = $(this).find('.instagram').html()
  $('.social').append(findfacebook)
  $('.social').append(findinstagram)
 })

 

}